export default {
  specialization: (param) => `profile/specialization?${buildQuery(param)}`,
  editspecialization: "profile/specialization/update",
  postspecialization: "profile/specialization",
  submit: "profile/specialization/submit",
  deletespecialization: (param) =>
    `profile/specialization/destroy?${buildQuery(param)}`,
};

function buildQuery(param) {
  const query = new URLSearchParams(param);
  return query.toString();
}
